// extracted by mini-css-extract-plugin
export var bottom = "index-module--bottom--T0Tz-";
export var dateWrapper = "index-module--dateWrapper--fZVlh";
export var fadein = "index-module--fadein--0IC7y";
export var items = "index-module--items--lb4Wp";
export var locationWrapper = "index-module--locationWrapper--GVzDy";
export var status = "index-module--status--Xfs28";
export var title = "index-module--title--o2xhz";
export var top = "index-module--top--sfeqL";
export var wrapper = "index-module--wrapper--vTOpz";